// U USO
// G ESTANDARIZA
// C CAMBIOS TOAL

export enum ReportType {
  REPORTE_PARADAS_MOVIMIENTOS = 'R001', // U N T
  REPORTE_RELENTI = 'R026',
  REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO = 'R002', // U T
  REPORTE_ENTRADA_SALIDA_GEOCERCAS = 'R003', // U T
  REPORTE_COMBUSTIBLE_GENERAL = 'R004', // G
  REPORTE_COMBUSTIBLE_RESUMEN = 'R042', // G
  REPORTE_GENERAL = 'R006',
  REPORTE_POSICION = 'R008', // T
  REPORTE_RECORRIDO = 'R050', // T
  // REPORTE_GERENCIAL = 'R020', // mina
  REPORTE_EVENTOS = 'R037', // T
  REPORTE_ATENCION_EVENTOS = 'R038',
  REPORTE_COORDENADAS_GEOCERCAS = 'R033',
  REPORTE_COORDENADAS_GEOPUNTOS = 'R034',
  REPORTE_COORDENADAS_GEOCERCAS_CIRCULARES = 'R035',
  REPORTE_EVENTOS_INTERNO = 'R040',
  REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO = 'R041',
  REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO = 'R044',
  REPORTE_ESTADO_TRANSMISION = 'R043',
  REPORTE_ESTADO_TRANSMISION_EVENTOS = 'R046',
  REPORTE_BOLIVIA = 'R045',
  REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL = 'R047',
  REPORTE_RESUMEN_POR_DIA_NUEVO = 'R048',
  REPORTE_MONITOREO_CANTIDAD_EVENTOS_POR_UNIDAD = 'R049',
  REPORTE_CHECKLIST = 'R053',
  REPORTE_OPERATIVIDAD_EQUIPO = 'R051',
  REPORTE_ACTIVITY_WATCH_LOCAL = 'R052',
  REPORTE_CONDUCTORES_ENROLADOS = 'R054',
  REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL = 'R055',
  REPORTE_EVENTOS_FORMATO_PAXI = 'R056',
  REPORTE_PARADAS_MOVIMIENTOS_NUEVO = 'R057',
  REPORTE_PRIMER_MOVIMIENTO = 'R058',
  REPORTE_PARADAS_MOVIMIENTOS_ENHANCED = 'R059',
  UNDEFINED = "R000",
}
